import { Valutazione } from './../models/Valutazione';
import { Component, OnInit } from '@angular/core';
import { ApiRestService } from './../_service/api-rest.service';
import { ValutazioniStoreService } from '../_service/valutazioni-store.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {Categorie} from "../../Progetti/Models/Categorie";
import {RicercaPaginazione} from "../../Admin/models/sendpersonale";
import {FileStoreService} from "../../shared/_services/file-store.service";
import {Persona} from "../../Admin/models/persona";
import {ApiRestService as PersonaApiRestService} from "../../Admin/_service/api-rest.service";
import {Azienda} from "../../Admin/models/Azienda";

@Component({
  selector: 'app-Valutazione',
  templateUrl: './Valutazione.component.html'
})
export class ValutazioneComponent implements OnInit {
  categoriedropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: true,
    textField: 'categoria',
    idField:'id',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  userDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField:'id',
    textField: 'fullName',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  clienteDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField:'id',
    textField: 'nominativo',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  managers: Persona[] = [];
  selectedManagers: Persona[] = [];
  CategorieLineare: Categorie[] = [];
  CategorieSelezionate: Categorie[] = [];
  subscriptions: Subscription = new Subscription();
  selected: Valutazione = new Valutazione();
  isAddable: boolean;
  isEditable: boolean;
  Stampe
  clienti: Azienda[] = [];
  clientiSelezionati: Azienda[] = [];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private datepipe: DatePipe,
    private ApiRestService: ApiRestService,
    private Store: ValutazioniStoreService,
    private toastService: ToastrService,
    private filestore: FileStoreService,
    private personaApiRestService : PersonaApiRestService,
  ) { }

  ngOnInit() {
    this.subscriptions.add(this.Store.$showAddForm.subscribe(x => this.isAddable = x));
    this.subscriptions.add(this.Store.$editable.subscribe(x => this.isEditable = x));
    this.subscriptions.add(this.Store.$stampe.subscribe(x => this.Stampe = x));
    this.subscriptions.add(this.Store.$selected.subscribe(x => this.CompilaDati(x)));
  }
  getCategorieListanofigli(){
    this.ApiRestService.getCheckListCategorie().subscribe(data=>this.CategorieLineare = data);
  }
  filtroCategoria() {
      this.getCategorieListanofigli();
  }
  CompilaDati(item: Valutazione) {
    this.selected = item;
    if(item?.manager)
      this.selectedManagers = [item.manager];
    if(item?.clienteObject)
      this.clientiSelezionati = [item.clienteObject];
    if(item)
    this.selected.employers = item?.employers ?? [];
    // if (item?.data_inizio_prevista)
    //   item.data_inizio_prevista = this.datepipe.transform(item.data_inizio_prevista, 'yyyy-MM-ddTHH:mm');
    // if (item?.data_fine_prevista)
    //   item.data_fine_prevista = this.datepipe.transform(item.data_fine_prevista, 'yyyy-MM-ddTHH:mm');
    // if (item?.data_inizio_effettiva)
    //   item.data_inizio_effettiva = this.datepipe.transform(item.data_inizio_effettiva, 'yyyy-MM-ddTHH:mm');
    // if (item?.data_fine_effettiva)
    //   item.data_fine_effettiva = this.datepipe.transform(item.data_fine_effettiva, 'yyyy-MM-ddTHH:mm');
    this.filestore.SetListaFile(item?.files);
    console.log(item);
  }
  saveClick() {
    this.selected.manager = this.selectedManagers?.length > 0 ? this.selectedManagers[0]?.id : undefined;
    this.selected.cliente = this.clientiSelezionati?.length > 0 ? this.clientiSelezionati[0].id : undefined;
    console.log(this.selected)
    if (!this.selected.id) {
      this.ApiRestService.addValutazione(this.selected).subscribe(() => {
        this.goBack();
      });
    } else{
      this.ApiRestService.updateValutazione(this.selected).subscribe((data) => {
        this.Store.updateSelected(this.selected);
        this.toastService.success("Modifiche apportate","Success!!")
        this.goBack();
      });
    }
  }
  goBack() {
    this.Store.updateEditable(false);
    this.Store.updateShowAddForm(false);
    if (this.selected && !isNaN(this.selected.id))
      this.Store.get(this.selected);
    this.closeBtnClick();
    this.router.navigate([this.route.snapshot.queryParams[' valutazioni/lista '] || 'valutazioni/lista',]);
  }
  closeBtnClick() {
   //this.modalService.dismissAll();
  }

  managerFilter(text:string) {
    this.personaApiRestService.getListaPersonale({page:0, size: 10, nome: text}).subscribe(data =>{
      this.managers = data?.data ?? [];
    })
  }
  ClientFilter(text:string) {
    this.personaApiRestService.getListaAziende({page:0, size: 10, nome: text}).subscribe(data =>{
      this.clienti = data?.data ?? [];
    })
  }

  catChanged() {
    this.selected.checks = [];
    this.CategorieSelezionate?.forEach(element=>{
      this.addCheck(this.CategorieLineare?.find(x=> x.id == element.id));
    })
  }

  addCheck(element){
    console.log(element);
    this.ApiRestService.getCheckList({page:0, size:15, cat_id: element.id}).subscribe(data=>{
      if(data?.data)
        this.selected.checks = this.selected.checks.concat(data.data);
      if(element.figli?.length>0)
        element.figli.forEach(cat=>{
          this.addCheck(cat)
        });
    })
  }


  onFileChanged() {
    this.Store.updateSelected(this.selected)
  }

  clienteChange() {
    if(this.clientiSelezionati?.length > 0 && !this.selected?.id)
    this.personaApiRestService.getInfoAziende(this.clientiSelezionati[0]).subscribe(data=>{
      this.selected.nominativo = data.nominativo;
      this.selected.indirizzo = data.indirizzo;
      this.selected.cap = data.cap;
      this.selected.citta = data.citta;
      this.selected.provincia = data.provincia;
      this.selected.nazione = data.nazione;
      this.selected.email = data.email;
      this.selected.telefono = data.telefono;
      this.selected.pec = data.pec;
      this.selected.codice_univoco = data.codice_univoco;
      this.selected.piva = data.piva;
      this.selected.cf = data.cf;
    })
  }
}
